import { useRequest } from 'ahooks'

import { confirmBidRecordApi } from '@eastcoal/api/trade/bidRecordOperation/confirmBidRecord'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { BidRecordStatus } from '@eastcoal/shared/enums/BidRecordStatus'

import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { BidRecordConfirmButtonProps } from './interface'

export const BidRecordConfirmButton = ({
  record: { id, status }
}: BidRecordConfirmButtonProps) => {
  const { message } = useFeedback()
  const { reload } = useRemoteTableStore(state => pick(state, ['reload']))
  const { tableRef } = useAuctionListStore(state => pick(state, ['tableRef']))
  const { loading, refresh } = useRequest(
    () =>
      confirmBidRecordApi({
        bidId: id
      }),
    {
      manual: true,
      onSuccess() {
        message.success('确认成功')
        // 刷新出价列表
        reload()
        // 刷新竞价列表
        tableRef.current?.reload()
      }
    }
  )

  return status === BidRecordStatus.WAIT_PLATFORM_CONFIRM ? (
    <ConfirmButton
      loading={loading}
      message='确定允许使用该报价成交吗？'
      onConfirm={refresh}
    >
      确认成交
    </ConfirmButton>
  ) : null
}
